export default "__VITE_ASSET__BXbL_2La__"